// extracted by mini-css-extract-plugin
module.exports = {"p__grid":"ProductsGrid_p__grid__3r6q6"};